import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNotification } from '../../../hooks/useNotification';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { useLocation, useNavigate } from 'react-router';
import { useForm } from '../../../hooks/useForm';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';

import { DialogSelectCompany } from '../../../components/dialogs/DialogSelectCompany';
import { ActionButtons } from '../../../components/others/ActionButtons';
import { ProductsForm } from '../../../components/invoice/ProductsForm';
import LoadingOverlay from '../../../components/others/LoadingOverlay';
import { getCompanies } from '../../../services/client.service';
import { FormOpportunity } from '../components/FormOpportunity';
import { AddMeeting } from '../components/dialogs/AddMeeting';
import { fetchServiceByIdOpportunity, insertDataAttachment, insertDataService, updateDataService } from '../../../services/meetings.service';
import { fetchOpportunityId, insertOpportunity, updateOpportunity, fetchProductsOpportunity, fecthProductsPrBusinessLine } from "../../../services/opportunity.service";

export const LayoutOpportunity = () => {
  const { t } = useTranslation();
  const [sendNotification] = useNotification();
  const [{ userSession }] = useDataAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const productsFormRef = useRef();
  const formRef = useRef();

  const model = {
    name: '',
    id_company: 0,
    id_contact: '',
    id_client: '',
    area: '',
    business_line: '',
    expected_closing_date: new Date(),
    closing_probability: '',
    opportunity_stage: 'Prospección',
    monthly_price: 0,
    paymentTermDays: '30',
    extension: '',
    sale_type: 'Venta Nueva',
    step_to_follow: '',
    created_by: `${userSession.username}`,
    contract_time: '12',
    approved_budget: '',
    client_need_rate: '',
    cost_center: '',
    delivery_address: '',
    details: '',
    identified_pain: '',
    user_name: '',
    observations: '',
    identified_competence: '',
    reasons_id: [],
    reason_other: '',
    closing_date: new Date(),
    proposed_date: new Date(),
    closing_conditions: '',
    client_order_number: '',
    phone: '',
    price: '0,00',
    products: []
  }

  const [opportunity, handleInputChange, handleDirectInputChange, setAllInfo] = useForm(model);
  const [edit, setEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [openDialogCompany, setOpenDialogCompany] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [attachment, setAttachment] = useState([]);
  const [idCompany, setIdCompany] = useState("");
  const fetchOpportunityData = useCallback(async (idOpportunity) => {
    try {
      const [opportunityRes, productsRes, meetingResponse] = await Promise.all([
        fetchOpportunityId(idOpportunity, userSession.token),
        fetchProductsOpportunity(idOpportunity, userSession.token),
        fetchServiceByIdOpportunity(userSession.token, idOpportunity)
      ]);
      if (opportunityRes.status === 200 && productsRes.status === 200) {
        const opportunityData = {
          ...opportunityRes.data,
          expected_closing_date: moment(opportunityRes.data.expected_closing_date.split('T')[0], 'YYYY-MM-DDTHH:mm').toDate(),
          products: productsRes.data || [],
        };

        setIdCompany(opportunityData.id_company)
        setAllInfo(opportunityData);
        setEdit(true);
      }
      if (meetingResponse.status === 200) {
        let data = meetingResponse.data;
        if (!Array.isArray(data)) {
          data.meeting_date = data.meeting_date.replace(':00Z', '');
          data = [data];
        } else {
          data = data.map(item => ({
            ...item,
            meeting_date: item.meeting_date.replace(':00Z', '')
          }));
        }
        setMeetings(data);
      }

    } catch (error) {
      console.error("Error fetching opportunity data:", error);
    }
  }, [userSession.token]);
  
  useEffect(() => {
    if (location.state && location.state.config) {
      const { config } = location.state;
      if (config.data?.work_flow === 'FLOW_PROCESS-VIEW_OPPORTUNITY' ||
        config.data?.work_flow === 'FLOW_PROCESS-VIEW_REPORTE_OPPORTUNITY'
      ) {
        setIsView(true);
      }
      if (config.data?.id) {
        fetchOpportunityData(config.data?.id);
      } else {
        const fetchDataCompany = async () => {
          try {
            setLoading(true);
            const response = await getCompanies('50', userSession.token);//El id user action se debe cambiar a worflow o se debe agregar en el .env
            setCompanies(response.data || []);
            if (response.data && response.data.length === 1) {
              const dto = response.data[0];
              setIdCompany(dto.id_company)
              handleDirectInputChange("id_company", idCompany);
              setOpenDialogCompany(false);
            }
            else
              setOpenDialogCompany(true);
          } catch (e) {
            console.error(e.message);
          } finally {
            setLoading(false);
          }
        }
        fetchDataCompany();
      }
    }
  }, [fetchOpportunityData, location.state, userSession.token])

  useEffect(() => {
    const loadProducts = async () => {
      if (idCompany !== "" && opportunity.business_line !== "") {
        try {
          const response = await fecthProductsPrBusinessLine(idCompany, opportunity.business_line, userSession.token);
          console.log("response ", response);
          if (response.status === 200 && response.data) {
            const products = [
              ...response.data.map(item => {
                const existing = opportunity.products.find(p => p.id_product_service === item.id_product_service);
                return existing ? { ...item, cantidad: existing.cantidad } : item;
              }),
              ...opportunity.products.filter(p => !response.data.some(item => item.id_product_service === p.id_product_service))
            ];
            handleDirectInputChange("products", products);
          }
        } catch (error) {
          console.error("Error fetching products:", error);
        }
      }
    };
    loadProducts();
}, [idCompany, opportunity.business_line, userSession.token]);


  const handleSubmit = async () => {
    let meetingId;
    let response;
    try {
      const isValidForm = formRef.current?.validForm();
      const isValidProductsForm = productsFormRef.current?.validForm();
      if (isValidForm && isValidProductsForm) {
        setLoading(true);
        const data = JSON.stringify({
          ...opportunity,
          closing_probability: `${parseFloat(opportunity.closing_probability) || 0}`,
          approved_budget: `${parseFloat(opportunity.approved_budget) || 0}`,
        });
        if (edit) {
          await updateOpportunity(data, userSession.token);
          let msgList = [];
          for (const meeting of meetings) {
            const { attachments, ...meetingWithoutAttachments } = meeting;
            const meetingWithOpportunity = {
              ...meetingWithoutAttachments,
              followed_up_by: Array.isArray(meeting.followed_up_by)
                ? meeting.followed_up_by.join(",")
                : meeting.followed_up_by,
            };
            if (meeting.id_commercial_opportunity === '') {
              meetingWithOpportunity.id_commercial_opportunity = opportunity.id_commercial_opportunity
              response = await insertDataService(meetingWithOpportunity, userSession.token);

            } else {
              response = await updateDataService(meetingWithOpportunity, userSession.token);
            }
            meetingId = response.data?.[0]?.Id || response.data?.[0]?.id;
            if (response.status === 200 && meetingId) {
              for (const file of meeting.attachments || []) {
                if (!file?.added) continue;
                try {
                  const res = await saveAttachment(file, meetingId);
                  if (!(res.status === 200 && res.data?.RowsAffected > 0)) {
                    msgList.push(file.name);
                  }
                } catch (err) {
                  console.log("Error al subir adjunto:", err);
                  msgList.push(file.name);
                }
              }
            }
          }
          sendNotification({
            msg: msgList.length > 0
              ? `Información actualizada, pero fallaron adjuntos: ${msgList.join(', ')}`
              : 'Datos del documento actualizado con éxito.',
            variant: msgList.length > 0 ? 'warning' : 'success',
          });

          Cancel();
        } else {
          const response = await insertOpportunity(data, userSession.token);
          const idOp = response.data[0].id;
          let msgList = [];
          for (const meeting of meetings) {
            const { attachments, ...meetingWithoutAttachments } = meeting;
            const meetingWithOpportunity = {
              ...meetingWithoutAttachments,
              id_commercial_opportunity: idOp,
              followed_up_by: Array.isArray(meeting.followed_up_by)
                ? meeting.followed_up_by.join(",")
                : meeting.followed_up_by,
            };
            const response = await insertDataService(meetingWithOpportunity, userSession.token);
            const meetingId = response.data[0].Id;
            if (response.status === 200 && meetingId) {
              if (meeting.attachments?.length > 0) {
                for (const file of meeting.attachments) {
                  try {
                    const res = await saveAttachment(file, meetingId);
                    if (!(res.status === 200 && res.data?.RowsAffected > 0)) {
                      msgList.push(file.name);
                    }
                  } catch (err) {
                    msgList.push(file.name);
                  }
                }
              }
            }
          }

          if (msgList.length > 0) {
            sendNotification({
              msg: t('messages.attachmentUploadFailed', { files: msgList.join(', ') }),
              variant: "error",
            });
            Cancel();
          }
          Cancel();
        }
        setLoading(false);
      } else {
        sendNotification({
          msg: t("validation.requiredFieldsMissing"),
          variant: 'error',
        });
      }
    } catch (error) {
      console.error("LayoutOpportunity submit response: ", error.message);
      setLoading(false);
      sendNotification({
        msg: t("messages.saveError"),
        variant: 'error',
      });
    }
  };

  const saveAttachment = async (data, id) => {
    const res = await insertDataAttachment({
      id_flow: "900114098-API-UPLOAD_ATTACHMENT_S3_SAVE_DB",
      id_company: idCompany,
      name: data.name.replace(/\s+/g, '_'),
      file: data.bytes,
      id_user_action: "MENU-MEETING",
      id_unique: id,
    },
      userSession.token
    );
    return res;
  }
  const Cancel = () => {
    setOpenDialogCompany(false);
    navigate(-1)
  };

  const handleConfirmAction = useCallback(async (dto) => {
    handleDirectInputChange("id_company", dto.id_company);
    setIdCompany(dto.id_company)
    setOpenDialogCompany(false);
  }, []);

  return (
    <Box sx={{ mx: 'auto' }}>
      <Card >
        <CardContent>
          <Typography variant="h6" gutterBottom>
            {t("crm.opportunity")}
          </Typography>

          <FormOpportunity
            ref={formRef}
            dto={opportunity || {}}
            handleInputChange={handleInputChange}
            handleDirectInputChange={handleDirectInputChange}
            isView={isView}
          />

          <ProductsForm
            ref={productsFormRef}
            dto={opportunity}
            handleInputChange={handleInputChange}
            handleDirectInputChange={handleDirectInputChange}
            isOpportunity={true}
            edit={edit}
            isView={isView}
          />

          <AddMeeting
            idCompany={idCompany}
            meetings={meetings}
            setMeetings={setMeetings}
            setLoading={setLoading}
            attachment={attachment}
            setAttachment={setAttachment}
            edit={edit}
            isView={isView}
          />

          <ActionButtons
            onCancel={Cancel}
            onSubmit={handleSubmit}
            submitLabel={'Guardar'}
            disabledSubmit={isView}
          />
        </CardContent>
      </Card>
      <DialogSelectCompany
        titleDialog={'Selecione una empresa'}
        openDialogConfirm={openDialogCompany}
        handleCancelConfirm={Cancel}
        handleConfirmAction={handleConfirmAction}
        data={companies}
      />
      <LoadingOverlay isOpen={loading} />
    </Box>
  );
};